import { PlatformType, SystemType } from '@nibfe/mkt-env-api';
import { getPlatformType, getSystemType } from '@nibfe/mkt-env-api';
import { isdpHost } from './constant';
import qs from 'querystring';
import { format } from './dateTool';
const platformType = getPlatformType();
const systemType = getSystemType();
const wxPreUrl = '/index/pages/h5/traffic-act/h5?f_userId=0&f_token=0&f_openId=1&app_version=1&f_ci=0&weburl=';
// 获取url查询参数
export const getEntryParams = (url) => {
    const _url = url || '';
    const list = decodeURIComponent((_url.split('?') || []).slice(1).join('?')).split('&');
    const entryParams = list.filter(str => str != null && str.length).reduce((pre, cur) => {
        const pairs = cur.split('=');
        const key = pairs[0];
        const value = pairs[1];
        return Object.assign(Object.assign({}, pre), { [key]: value });
    }, {});
    return entryParams;
};
export var getFlightListUrl = function getFlightListUrl(param) {
    var mtUrl = 'imeituan://www.meituan.com/flight/flight_list?';
    var dpUrl = 'dianping://www.dianping.com/flight/flight_list?';
    const h5Url = 'https://awp.meituan.com/ctfe/flight_mrn_app_pre/traffic-flight-list/web/rn_flight_traffic-flight-list/FlightListPage.html?';
    var date = new Date(param.date).getTime() / 1000;
    var searchParam = {
        goDate: date,
        trafficsource: param.trafficsource || '',
        departCode: param.depart_code || '',
        arriveCode: param.arrive_code || '',
        departCityName: param.depart_name || '',
        arriveCityName: param.arrive_name || '',
        homePageFilterType: JSON.stringify(param.filter),
        extendData: param.extendData ? JSON.stringify(param.extendData) : '',
        isFromN6: '1',
        mode: 0,
        backDate: undefined
    };
    // 往返
    if (param.back_date) {
        var back_date = new Date(param.back_date).getTime() / 1000;
        searchParam.mode = 1;
        searchParam.backDate = back_date;
    }
    var search = {
        param: JSON.stringify(searchParam)
    };
    // 添加来源标识
    search.trafficsource = param.trafficsource || '';
    var url = mtUrl + qs.stringify(search);
    try {
        if (platformType === PlatformType.mtMinaWebview) {
            url = wxPreUrl + encodeURIComponent(h5Url + qs.stringify(search));
            return url;
        }
        if (systemType === SystemType.android) {
            if ([PlatformType.mtApp, PlatformType.mtAppWebView].includes(platformType)) {
                url = mtUrl + qs.stringify(search);
            }
            else if ([PlatformType.dpApp, PlatformType.dpAppWebView].includes(platformType)) {
                url = dpUrl + qs.stringify(search);
            }
            else {
                if (isdpHost) {
                    url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent(dpUrl + qs.stringify(search));
                }
                else {
                    url = 'https://m.dianping.com/cube/evoke/train/meituan.html?url=' + encodeURIComponent(mtUrl + qs.stringify(search));
                }
            }
        }
        else if (systemType === SystemType.ios) {
            if ([PlatformType.mtApp, PlatformType.mtAppWebView].includes(platformType)) {
                url = mtUrl + qs.stringify(search);
            }
            else if ([PlatformType.dpApp, PlatformType.dpAppWebView].includes(platformType)) {
                url = mtUrl + qs.stringify(search); //历史遗留问题，点评iOS跳转imeituan协议
            }
            else {
                if (isdpHost) {
                    // 增加中转页面
                    // url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent('dianping://flight_list?' + search);
                    url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent('https://m.dianping.com/awp/hfe/block/3620f5299cd2/103644/index.html?' + qs.stringify(search));
                }
                else {
                    url = 'https://m.dianping.com/cube/evoke/train/meituan.html?url=' + encodeURIComponent(mtUrl + qs.stringify(search));
                }
            }
        }
        else {
            // 按需求进行鸿蒙系统跳链调整
            if ([PlatformType.mtApp, PlatformType.mtAppWebView].includes(platformType)) {
                url = mtUrl + qs.stringify(search);
            }
            else if ([PlatformType.dpApp, PlatformType.dpAppWebView].includes(platformType)) {
                url = dpUrl + qs.stringify(search);
            }
            else {
                if (isdpHost) {
                    url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent(dpUrl + qs.stringify(search));
                }
                else {
                    url = 'https://m.dianping.com/cube/evoke/train/meituan.html?url=' + encodeURIComponent(mtUrl + qs.stringify(search));
                }
            }
        }
    }
    catch (error) {
        console.warn(error);
    }
    return url;
};
const guid = function () {
    var s = function () {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    };
    return s() + s() + '-' + s() + '-' + s() + '-' + s() + '-' + s() + s() + s();
};
// 机票 OTA页
export var getFlightOTAUrl = function getFlightOTAUrl(param) {
    var iosMT = 'imeituan://www.meituan.com/mrn?mrn_biz=flight&mrn_entry=traffic-flight&mrn_component=OtaListPage&';
    var androidMT = 'imeituan://www.meituan.com/flight/flight_ota_list?mrn_biz=flight&mrn_entry=traffic-flight&mrn_component=OtaListPage&';
    var iosDP = 'imeituan://www.meituan.com/traffic/mrn?mrn_biz=flight&mrn_entry=traffic-flight&mrn_component=OtaListPage&';
    var androidDP = 'dianping://www.dianping.com/flight/flight_ota_list?';
    var date = new Date(param.date).getTime();
    var uuid = guid() || '';
    var jumpData = param.jumpData || {};
    var stopCity = jumpData.stopCities && jumpData.stopCities[0];
    var arriveDate = format(new Date(jumpData.arriveDate), 'MM月DD日');
    var searchJson = {
        // 如果直接跳OTA列表，但参数又不全的时候，可以选以下参数，跳到OTA页后会先请求航班详情接口再调OTA列表接口
        // "fromH5":"1",
        // "departCode":"PEK",
        // "price":"310",
        // "arriveCode":"SHA",
        // "date":"1710547200000",
        // "flightNo":"KN5977",
        // "h5FlightInfo":{
        //     "fromH5":"1",
        //     "departCode":"PEK",
        //     "price":"310",
        //     "arriveCode":"SHA",
        //     "date":"1710547200000",
        //     "flightNo":"KN5977",
        //     "departCityName":"北京",
        //     "trafficsource":"_flightH5_flight_domestic_product_low_priced_subscribe_detail_a",
        //     "arriveCityName":"上海"
        // },
        // "departCityName":"北京",
        // "trafficsource":"_flightH5_flight_domestic_product_low_priced_subscribe_detail_a",
        // "arriveCityName":"上海"
        datecheck: date,
        trafficsource: 'cube_carrier_product',
        priceToken: '',
        queryid: uuid,
        flightType: 0,
        flight_type: '单程',
        originFlightLowPrice: '' + jumpData.price,
        filter: JSON.stringify([]),
        extendData: param.extendData ? JSON.stringify(param.extendData) : '',
        flightInfo: {
            fn: jumpData.flightNo || '',
            departstation: jumpData.departTerminal || '',
            arrivestation: jumpData.arriveTerminal || '',
            sharefn: jumpData.shareFlightNo,
            sharecomany: jumpData.shareCarrierName,
            stops: stopCity && stopCity.length > 0 ? [{
                    stop_city: stopCity
                }] : [],
            stopResTime: jumpData.stopTimeHmDesc,
            arriveDate: arriveDate,
            planetypeinfo: jumpData.planeName,
            arriveairportcode: jumpData.arriveAirportCode,
            companyShortName: jumpData.carrierName,
            arrive: jumpData.arriveCityName,
            arrivetime: jumpData.arriveTime,
            departairport2: jumpData.departAirportName,
            image: jumpData.carrierLogo,
            arriveairport2: jumpData.arriveAirportName,
            departtime: jumpData.departTime,
            price: '' + jumpData.price,
            hasfood: jumpData.hasMeal,
            coname: jumpData.carrierName,
            departairportcode: jumpData.departAirportCode,
            depart: jumpData.departCityName,
            punctual_rate: jumpData.punctualityRate,
            flightInfoId: jumpData.flightNo || '',
            planeTypeInfo: jumpData.planeName,
            arriveCityCode: jumpData.arriveCityCode,
            is_shared: jumpData.isShared,
            flytime: jumpData.runTimeDesc,
            departCityCode: jumpData.departCityCode,
            date: date
        },
        preNetwork: {
            cabinType: '1',
            // 经济舱1 商务舱2
            hasSlfOfRoundTrip: '0',
            queryId: uuid,
            priceToken: '',
            flightInfoId: jumpData.flightNo || '',
            depCityCode: jumpData.departCityCode,
            arrCityCode: jumpData.arriveCityCode,
            flightNo: jumpData.flightNo || '',
            flightNoSecond: jumpData.flightNo || '',
            date: param.date,
            filter: JSON.stringify([]),
            departTime: jumpData.departTime,
            departAirportCode: jumpData.departAirportCode,
            arriveAirportCode: jumpData.arriveAirportCode,
            isShareFlight: jumpData.isShared === 1 ? 'true' : 'false',
            abTest: 'SAKABTestRule_a',
            isMilitaryRequest: '0',
            trafficsource: 'cube_carrier_product',
            originFlightLowPrice: '' + jumpData.price
        }
    };
    var search = {
        param: JSON.stringify(searchJson)
    };
    var url = iosMT + qs.stringify(search);
    const h5Url = 'https://awp.meituan.com/ctfe/flight_mrn_app_pre/traffic-flight/web/rn_flight_traffic-flight/OtaListPage.html?';
    try {
        if (platformType === PlatformType.mtMinaWebview) {
            url = wxPreUrl + encodeURIComponent(h5Url + qs.stringify(search));
            return url;
        }
        if (systemType === SystemType.android) {
            if ([PlatformType.mtApp, PlatformType.mtAppWebView].includes(platformType)) {
                url = androidMT + qs.stringify(search);
            }
            else if ([PlatformType.dpApp, PlatformType.dpAppWebView].includes(platformType)) {
                url = androidDP + qs.stringify(search);
            }
            else {
                if (isdpHost) {
                    url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent(androidDP + qs.stringify(search));
                }
                else {
                    url = 'https://m.dianping.com/cube/evoke/train/meituan.html?url=' + encodeURIComponent(androidMT + qs.stringify(search));
                }
            }
        }
        else if (systemType === SystemType.ios) {
            if ([PlatformType.mtApp, PlatformType.mtAppWebView].includes(platformType)) {
                url = iosMT + qs.stringify(search);
            }
            else if ([PlatformType.dpApp, PlatformType.dpAppWebView].includes(platformType)) {
                url = iosDP + qs.stringify(search); //历史遗留问题，点评iOS跳转imeituan协议
            }
            else {
                if (isdpHost) {
                    // 增加中转页面
                    // url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent('dianping://flight_list?' + search);
                    url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent('https://m.dianping.com/awp/hfe/block/3620f5299cd2/103644/index.html?' + qs.stringify(search));
                }
                else {
                    url = 'https://m.dianping.com/cube/evoke/train/meituan.html?url=' + encodeURIComponent(iosMT + qs.stringify(search));
                }
            }
        }
        else {
            if ([PlatformType.mtApp, PlatformType.mtAppWebView].includes(platformType)) {
                url = iosMT + qs.stringify(search);
            }
            else if ([PlatformType.dpApp, PlatformType.dpAppWebView].includes(platformType)) {
                url = iosDP + qs.stringify(search); //历史遗留问题，点评iOS跳转imeituan协议
            }
            else {
                if (isdpHost) {
                    // 增加中转页面
                    // url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent('dianping://flight_list?' + search);
                    url = 'https://w.dianping.com/cube/evoke/dianping.html?url=' + encodeURIComponent('https://m.dianping.com/awp/hfe/block/3620f5299cd2/103644/index.html?' + qs.stringify(search));
                }
                else {
                    url = 'https://m.dianping.com/cube/evoke/train/meituan.html?url=' + encodeURIComponent(iosMT + qs.stringify(search));
                }
            }
        }
    }
    catch (error) {
        console.warn(error);
    }
    return url;
};
export const isMTWX = () => {
    return getPlatformType() === PlatformType.mtMinaWebview;
};
